import React from 'react';
import { Wrapper } from './PostShareStyled';
import { IPostShareProps } from './interfaces';
import useShareLinks from './__utils__/useShareLinks';
import Social from '@components/Shared/Social';

const PostShare: React.FC<IPostShareProps> = () => {
  const shareData = useShareLinks();
  return (
    <Wrapper className="mt-4">
      <Social socialLinks={shareData} />
    </Wrapper>
  );
};

export default PostShare;
